import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const rowClassNames = (
  gridLayout,
  firstTitleColumn,
  lastTotalColumn,
  className,
  rowOnClick
) =>
  classnames(
    'table__row',
    { 'table__row--enable-hover': rowOnClick },
    { table__row__grid: gridLayout },
    { 'table__row__grid--first-title-column': gridLayout && firstTitleColumn },
    { 'table__row__grid--last-total-column': gridLayout && lastTotalColumn },
    className
  );

const TableRow = ({
  children,
  rowOnClick,
  item,
  gridLayout,
  firstTitleColumn,
  lastTotalColumn,
  className,
  rowKey
}) => (
  <ul
    className={rowClassNames(
      gridLayout,
      firstTitleColumn,
      lastTotalColumn,
      className,
      rowOnClick
    )}
    key={rowKey}
    onClick={e => rowOnClick && rowOnClick(item, e)}
    role='presentation'
    data-testid='tableRow'
  >
    {children}
  </ul>
);

TableRow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  rowOnClick: PropTypes.func,
  gridLayout: PropTypes.bool,
  firstTitleColumn: PropTypes.bool,
  lastTotalColumn: PropTypes.bool,
  item: PropTypes.object,
  className: PropTypes.string,
  rowKey: PropTypes.string
};

export default TableRow;
